module.exports = __webpack_public_path__ + "media/images/emoticons/ring-cf09ef5fbbfefdbc22536a56813215e1.gif";